import { BeforeAfterGallery } from '../before-after-gallery';

export class Procedure {
  public icon: string;
  public id: number;
  public name: string;
  public position: number;
  public slug: string;
  public galleries: BeforeAfterGallery[];

  constructor(data: any = {}) {
    this.icon = data.icon || '';
    this.id = data.id || void 0;
    this.name = data.name || void 0;
    this.slug = data.slug || void 0;
    this.position = data.position;
    this.galleries =
      (data.galleries && data.galleries.map((gallery) => new BeforeAfterGallery(gallery))) || [];
  }
}
